import script from "./price.vue?vue&type=script&setup=true&lang=ts"
export * from "./price.vue?vue&type=script&setup=true&lang=ts"

import "./price.vue?vue&type=style&index=0&id=6ffed598&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ffed598"]])

export default __exports__